import { AUTHENTICATION_SCOPES } from '../../context/IdentityContext'
import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser'
import { isOfficeInitialized } from '../../helpers/outlookHelper'

export default function useAcquireBootstrapToken() {
    return (username: string, pca: PublicClientApplication, handleBootstrapToken): Promise<string> => {
        if (isOfficeInitialized() && Office.context?.mailbox?.userProfile?.emailAddress.toLowerCase() === username) {
            return Office.auth
                .getAccessToken({ allowConsentPrompt: true, allowSignInPrompt: true })
                .then((result: string) => handleBootstrapToken(result))
                .catch(e => {
                    console.log(e)
                    throw e
                })
        } else {
            const account = pca.getAllAccounts().find(account => account.username.toLowerCase() === username)
            // TODO uncomment for HAM-2426
            // if (!account) {
            //     return Promise.reject()
            // }

            // Acquire the bootstrap token silently. This is possible when MSAL has already stored the authentication of
            // the current user.
            return pca
                .acquireTokenSilent({ scopes: AUTHENTICATION_SCOPES, account })
                .then((result: AuthenticationResult) => handleBootstrapToken(result.accessToken))
                .catch(e => {
                    console.log(e)
                    throw e
                })
        }
    }
}
